/* eslint-disable */
//require main files for webpack
require('./app/stylesheets/app.scss');
require('./app/javascripts/app.js');